import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-divider-dot',
  standalone: true,
  templateUrl: './divider-dot.component.html',
  styleUrl: './divider-dot.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerDotComponent {
  readonly size = input<number>(4);
}
